import { Component, OnInit } from '@angular/core';
import {
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { PriceListTemplateService } from 'src/app/services/sales/price-list-template.service';
import { ActivatedRoute, Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import { getEmptyGuid } from "../../../../services/util.service";
import { DialogService } from "src/app/services/dialog.service";
import { PriceListTemplate } from "src/app/models/sales/price-list-template";

@Component({
  selector: 'app-price-list-template-list',
  templateUrl: './price-list-template-list.component.html',
  styleUrls: ['./price-list-template-list.component.css']
})
export class PriceListTemplateListComponent implements OnInit {

  allData: any[] = [];
  filteredData: any[] = [];

  // Icon imports
  faPlus = faPlus;
  faTrash = faTrash;

  tableHeaders = [
    {
      title: "",
      type: "checkbox",
      id: "checked"
    },
    {
      title: "MODEL",
      type: "link",
      id: "model"
    },
    {
      title: "ENGINE CAP",
      type: "data",
      id: "engineCap"
    },
    {
      title: "SEQ",
      type: "data",
      id: "seq"
    },
    {
      title: "SUB SEQ",
      type: "data",
      id: "subSeq"
    },
    {
      title: "CATEGORY",
      type: "data",
      id: "category"
    },
    {
      title: "COE OFFSET",
      type: "data",
      id: "coe"
    },
    {
      title: "6 MTHS ROAD TAX",
      type: "data",
      id: "roadTax"
    },
    {
      title: "PRICE",
      type: "data",
      id: "price"
    },
    {
      title: "DESC",
      type: "data",
      id: "desc"
    },
    {
      title: "DISPLAY",
      type: "data",
      id: "display"
    },
    {
      title: "ID",
      type: "hidden",
      id: "id"
    }
  ];

  constructor(
    private priceListTemplateService: PriceListTemplateService,
    private notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
  ) {}

  ngOnInit(): void {
    this.getAllTemplates();
  }

  private getAllTemplates(): void {
    this.priceListTemplateService.getAllPriceListTemplates().subscribe(
      (response) => {
        this.allData = (response.body ?? []).map((template) => {
          return {
            "checked": false,
            "model": template.MODEL ?? "",
            "engineCap": template.ENGINECAP ?? "",
            "seq": template.SEQ ?? "",
            "subSeq": template.SUBSEQ ?? "",
            "category": template.CATEGORY ?? "",
            "coe": template.COE ?? 0,
            "roadTax": template.ROADTAX ?? 0,
            "price": template.Price ?? 0,
            "desc": template.StringDesc ?? "",
            "display": template.Display ?? "",
            "id": template.ID
          };
        });
        this.filteredData = [...this.allData];
      },
      (error) => {
        console.error("Error fetching price list templates:", error);
        this.notifier.notify('error', 'Error fetching price list templates.');
      }
    );
  }

  onSearch(searchValue: string): void {
    this.filteredData = this.allData.filter(item =>
      item.model.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.desc.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.category.toLowerCase().includes(searchValue.toLowerCase())
    );
  }

  openEntry(value: any) {
    this.router.navigate(["../price-list-template", value.id], {
      relativeTo: this.route,
    });
  }

  addEntry(): void {
    const emptyGuid = getEmptyGuid();
    this.router.navigate(["../price-list-template", emptyGuid], {
      relativeTo: this.route,
    });
  }

  async deleteSelectedEntries(): Promise<void> {
    const selectedItems = this.filteredData.filter(item => item.checked);
  
    if (selectedItems.length === 0) {
      this.notifier.notify('error', 'Please select at least one item to delete.');
      return;
    }
  
    const confirmed = await this.dialogService.openDeleteDialog(
      "selected Price List Template record(s)",
    );
    if (!confirmed) {
      return;
    }

    const ids: Pick<PriceListTemplate, "ID">[] = selectedItems.map((item) => ({
      ID: item.id,
    }));
    this.priceListTemplateService.deletePriceListTemplates(ids).subscribe({
      next: (response) => {
        if (response.code !== 0) {
          this.notifier.notify("error", response.message);
          return;
        }
        this.notifier.notify('success', 'Selected items deleted successfully.');
        this.getAllTemplates();
      },
      error: (error) => {
        console.error("Error deleting price list templates:", error);
        this.notifier.notify('error', 'Error deleting selected items.');
      }
    });
  }
  
}
